<svelte:options runes={false} />

<script>
  import { STRIPE_FEE_QUOTE_POLICIES, UNCONFIGURED_STRIPE_FEE_QUOTE_POLICY_ID } from '../../api/payments';
  import { INSTANCE_MODES } from '../../api/runtime-config';
  import CurrencySelect from './CurrencySelect.svelte';

  export let instanceMode;
  export let projectCurrency;
  export let savingProjectPolicy;
  export let onChangeProjectCurrency;
  export let settlementCadence;
  export let processorFeeQuotePolicyId;
  export let transferTax;
  export let payerFeeShareBps;
  export let operatorFeeShareBps;
  export let onSave;
</script>

<div class="policy-form">
  <h3>Payment policy</h3>
  {#if instanceMode === INSTANCE_MODES.SOLO}
    <p class="quiet">
      These values are retained with each payment for the shared settlement roadmap.
      Direct-account Checkout does not create a Transfer today.
    </p>
  {/if}
  <CurrencySelect
    label="Currency"
    value={projectCurrency}
    onChange={onChangeProjectCurrency}
  />
  <label>
    Settlement cadence
    <select bind:value={settlementCadence}>
      <option value="immediate">immediate</option>
      <option disabled value="daily">daily — coming later</option>
      <option disabled value="weekly">weekly — coming later</option>
      <option disabled value="monthly">monthly — coming later</option>
    </select>
  </label>
  <label>
    Stripe fee estimate
    <select bind:value={processorFeeQuotePolicyId}>
      <option value={UNCONFIGURED_STRIPE_FEE_QUOTE_POLICY_ID}>
        Manual only — no Stripe estimate
      </option>
      {#each STRIPE_FEE_QUOTE_POLICIES as policy (policy.policyId)}
        <option disabled={policy.currency !== projectCurrency} value={policy.policyId}>
          {policy.label} ({policy.currency})
        </option>
      {/each}
    </select>
  </label>
  <label class="inline-check">
    <input bind:checked={transferTax} type="checkbox" />
    transfer tax when settlement is available
  </label>
  <label>Payer fee share (bps)<input bind:value={payerFeeShareBps} min="0" max="10000" type="number" /></label>
  <label>Operator fee share (bps)<input bind:value={operatorFeeShareBps} min="0" max="10000" type="number" /></label>
  <button type="button" disabled={savingProjectPolicy} on:click={onSave}>
    {savingProjectPolicy ? 'Saving policy…' : 'Save policy'}
  </button>
</div>
